import { cn } from '../../lib/cn';
import type { HumanLoopRow } from '../../automationstudio/framework';

type Props = { items?: HumanLoopRow[] };

export function HumanInTheLoopPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.title} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{item.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{item.agent} · {item.mode}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            item.priority === 'critical' ? 'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300' :
            item.priority === 'high' ? 'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {item.priority}
          </span>
        </div>
      ))}
    </div>
  );
}
